import { useStaticQuery, graphql } from 'gatsby'

export const useAllCategoriesQuery = () => {
  const data = useStaticQuery(graphql`
    {
      allWpCategory {
        edges {
          node {
            id
            slug
            name
            uri
          }
        }
      }
    }
  `)

  return data?.allWpCategory?.edges
}
